import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32bf987b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalAddUserToGroup",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = { class: "modal-body content mx-0 p-0" }
const _hoisted_7 = { class: "row py-2 py-lg-4 px-3 gx-0 border-bottom" }
const _hoisted_8 = { class: "w-max-content col-3 col-form-label" }
const _hoisted_9 = { class: "w-max-content px-1 mx-3 mx-lg-0 col-lg-2 col-form-label" }
const _hoisted_10 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_11 = { class: "col-lg-12 px-0" }
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_15 = { class: "px-4" }
const _hoisted_16 = { class: "fw-bold py-4" }
const _hoisted_17 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_18 = { class: "list-id" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = { class: "row mx-0 px-0 d-flex justify-content-center flex-sm-row flex-column-reverse mb-4" }
const _hoisted_21 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_22 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { computed, onMounted, PropType, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { numberWithCommas } from '@/constants/common.ts'
import Button from '@/components/button/index.vue'
import Status from '@/components/status/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { GROUPS_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array as PropType<Array<{ management_no: string; family_name: string; given_name: string; display_name: string; user_type: number }>>,
  setGroupData: Function as PropType<any>,
  groupDataId: {
    type: String,
    default: '',
  },
  showDisplayName: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()
const modalAddToGroup = ref()
const modalConfirmAddToGroup = ref()

const listGroups = computed(() => store.getters[GROUPS_STORE.GETTERS.ALL_GROUPS])
const groupId = ref<string>('')
const selectError = ref<boolean>(false)



const statusMap: Record<string, string> = {
  leave: translate('SO10user30'),
  available: translate('OE12pause'),
}
const getItemDisplay = (item: any): string => {
  let displayName = `${item.family_name} ${item.given_name} ${statusMap[item.status] || ''}`
  if (props.showDisplayName) {
    displayName += ` (${item.display_name})`
  }
  return displayName
}

const onSubmit = (): void => {
  selectError.value = false
  if (!groupId.value) {
    selectError.value = true
    return
  } else {
    props.setGroupData(listGroups.value?.find((record) => record.id === groupId.value))
    modalAddToGroup.value.hide()
    modalConfirmAddToGroup.value.show()
  }
}

const reset = (): void => {
  selectError.value = false
  groupId.value = ''
}

onMounted(() => {
  modalAddToGroup.value = new Modal(document.getElementById('modalAddUserToGroup'))
  modalConfirmAddToGroup.value = new Modal(document.getElementById('modalConfirmAddUserToGroup'))
})

watch(
  () => props.groupDataId,
  () => (groupId.value = props.groupDataId)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE12addToGroup')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            onClick: reset,
            "aria-label": "Close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('OE12GroupName')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "aria-label": "Default select example",
                  name: "affiliation",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupId).value = $event))
                }, [
                  _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listGroups), (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.name), 9, _hoisted_13))
                  }), 128))
                ], 512), [
                  [_vModelSelect, groupId.value]
                ]),
                (selectError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(translate)('requiredSelect', 'グループ名')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(numberWithCommas)(__props.data?.length)) + _toDisplayString(_unref(translate)('selectingUserItems')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("ul", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "mb-2 d-flex align-items-center",
                      key: index
                    }, [
                      _createVNode(UserAliasIcon, {
                        userType: item?.user_type
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(item?.management_no), 1),
                      _createElementVNode("span", null, _toDisplayString(getItemDisplay(item)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: "secondary",
                    onClick: reset,
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(Button, {
                    title: _unref(translate)('confirm'),
                    type: "secondary",
                    onClick: onSubmit
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})